import { render, staticRenderFns } from "./DatatableListUsers.vue?vue&type=template&id=2571a04d"
import script from "./DatatableListUsers.vue?vue&type=script&lang=js"
export * from "./DatatableListUsers.vue?vue&type=script&lang=js"
import style0 from "./DatatableListUsers.vue?vue&type=style&index=0&id=2571a04d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports